module.exports = __webpack_public_path__ + "img/instagram.1f2c47db.svg";